import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import MapComponent from "shared-components/src/components/map/map.component";

const legendItems = [
  { color: "#2e7d32", label: "legend_not_irrigation" },
  { color: "#0288d1", label: "legend_early_irrigations" },
  { color: "#ed6c02", label: "legend_late_irrigation" },
  { color: "#d32f2f", label: "legend_limit_irrigation" },
];

const MapHomeComponent = ({ fieldsIrrigationStatus, isLoading }) => {
  const { t } = useTranslation();
  const fields = useSelector((state) => state.fields?.data);

  const getIrrigationColor = (fieldId) => {
    const status = fieldsIrrigationStatus[fieldId];
    if (!status) return "#4caf50";

    if (status.isUrgent) return "#f44336";
    if (status.isOptimalRange) return "#ff9800";
    if (status.isSuggestedDay) return "#2196f3";
    return "#4CAF50";
  };

  const layers = fields?.map((field) => ({
    id: field.id,
    bounds: field.polygons?.[0]?.position,
    color: getIrrigationColor(field.id_thing),
    field: field,
  }));

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <MapComponent
        shapefile={null}
        polygons={null}
        layers={!isLoading ? layers : []}
        markersWithNumber={null}
      />

      <Box width="100%" p={1} display="flex">
        <Stack spacing={1} direction="row">
          {legendItems.map((item, index) => (
            <Stack key={index} direction="row" spacing={1} alignItems="center">
              <Box
                width={20}
                height={20}
                bgcolor={item.color}
                borderRadius={1}
              />
              <Typography variant="body2">{t(`home.${item.label}`)}</Typography>
            </Stack>
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default MapHomeComponent;
